<!--begin::Logo image-->
<a
  routerLink="/dashboard"
  class="w-100 d-flex align-items-center outline-none justify-content-center gap-5 p-5"
>
  <img
    alt="Logo"
    src="./assets/img/logo-sm.png"
    class="h-40px app-sidebar-logo-minimize"
  />
  <img
    alt="Logo"
    src="./assets/img/logo-sm.png"
    class="h-50px app-sidebar-logo-default p-1 pe-0"
  />
  <img
    alt="Logo"
    src="./assets/img/logo.png"
    class="h-50px app-sidebar-logo-default"
  />
</a>
<!--end::Logo image-->
